<ng-template let-modal #confirmPostReaction>
  <div class="w-100 d-flex justify-content-center align-items-center flex-column">
    <p class="mb-2" style="color: var(--primary); font-weight: bold; font-size: 1.2rem;">Please select your reaction:
    </p>

    <div class="w-100 d-flex justify-content-center">
      <button class="btn-outline-primary btn btn-sm like-btn rxn-btn mr-3" (click)="toggleUploadRxn(1)"
        [class.active]="uploadedImage?.myRxn === 1">{{uploadedImage?.likeCounts}} <i
          class="fa fa-thumbs-up"></i></button>

      <button class="btn-outline-primary btn btn-sm dislike-btn rxn-btn" (click)="toggleUploadRxn(2)"
        [class.active]="uploadedImage?.myRxn === 2">{{uploadedImage?.dislikeCounts}} <i
          class="fa fa-thumbs-down"></i></button>
    </div>


  </div>

</ng-template>
<ng-template let-modal #selectVisibleTabs>
  <div class="box">
    <label class="toggle">Show Category Tabs</label>
    <div>
      <ng-container *ngFor="let i of totalTabs">
        <ng-container *ngIf="!['Map', 'Popular'].includes(i.title)">
          <div class="box__item" [ngClass]="{ active: i.condition }">
            <input [id]="i?.title" style="opacity: 1; width: 20px" type="checkbox" (change)="handleHideCategoryTab(i)"
              [(ngModel)]="i.condition" />
            <label [for]="i?.title">{{ i?.title | titlecase }}</label>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <button class="my-button-3 mt-2" (click)="saveTabPreferences()"><i class="fa fa-save"></i> Save</button>
  </div>
</ng-template>



<ng-template let-modal #selectSubCategories>
  <div class="box">
    <label class="toggle">Select SubCategories</label>
    <div>
      <ng-container *ngFor="let i of mapSubCategories">
        <div class="box__item" [ngClass]="{ active: i.isChecked }">
          <input [id]="i?.categoryName" style="opacity: 1; width: 20px" type="checkbox" (change)="handleLoadProducts()"
            [(ngModel)]="i.isChecked" />
          <label [for]="i?.categoryName">{{ i?.categoryName | titlecase }}</label>
        </div>
      </ng-container>
    </div>
    <button class="my-button-3 mt-2" (click)="closeAllModals()"><i class="fa fa-save"></i> Done</button>
  </div>
</ng-template>

<div class="products">
  <div class="products-title">
    See What’s Near You
    <svg viewBox="0 0 800 800" fill="none">
      <path d="M800 0H0V800H800V0Z" fill="white" fill-opacity="0.01" />
      <path
        d="M400 733.333C400 733.333 650 533.333 650 316.666C650 178.595 538.072 66.6665 400 66.6665C261.928 66.6665 150 178.595 150 316.666C150 533.333 400 733.333 400 733.333Z"
        fill="var(--primary)" stroke="#0000003d" stroke-width="66.6667" stroke-linejoin="round" />
      <path
        d="M400 416.666C455.228 416.666 500 371.895 500 316.667C500 261.438 455.228 216.667 400 216.667C344.772 216.667 300 261.438 300 316.667C300 371.895 344.772 416.666 400 416.666Z"
        fill="var(--primary)" stroke="white" stroke-width="66.6667" stroke-linejoin="round" />
    </svg>
  </div>
  <app-nearby-all-services (onViewProducts)="viewProductDetails($event)" [userRegionId]="userRegionId"
    [userRegionName]="userRegionName"></app-nearby-all-services>
  @if (viewTabs) {
  <div style="position: relative; top: 0.5rem">
    <app-my-tabs [tabs]="tabs" (tabChange)="updateSelMenu($event)">
      <div allTab>
        <!-------------------------categories carousel---------------------------->
        <app-my-carousel-swiper [slide]="mapCategories" [centerSlider]="true" class="my-carousel-width-auto"
          [config]="carouselOptionsCate">
          <!-- <div class="swiper-slide">
            <div class="card-cate" (click)="loadMapCategory('all')" [class.active]="selectedMapCategoryId == 'all'">
              <img style="height: 3.5em" loading="lazy" src="../../../../../../../assets/images/all-icon.png" alt="" />
              <div class="card-cate__title sm">
                <p>All</p>
              </div>
            </div>
          </div> -->
          @for (cat of mapCategories; track cat) {
          <div class="swiper-slide">
            <div class="card-cate" (click)="loadMapCategory(cat)" [class.active]="selectedMapCategoryId == cat.id">
              <img loading="lazy" src="{{ imgUrl }}{{ cat.image }}" alt="" />
              <div class="card-cate__title sm">
                <p>{{ cat.name | titlecase }}</p>
              </div>
            </div>
          </div>
          }
        </app-my-carousel-swiper>
        <!------------------------------------------------------------------------------>

        <!-- 
        <div [class.d-none]='indexFilter == "map"'>
          <button class="btn btn-secondary w-100 mb-2 d-block d-md-none" (click)="showMap = !showMap">
            <i [ngClass]="showMap ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
            {{ showMap ? "Hide Map" : "Show Map" }}
          </button>
          <div class="mb-3">
            <div id="map_1" class="map"></div>
          </div>
        </div> -->
        @if (isLoadingAllProduct && indexFilter != "map") {
        <!--To avoid rebuilding each time -->
        <div class="grid-product">
          <div class="card-skeleton" *ngFor="let item of [1, 1, 1, 1, 1]">
            <div class="image-placeholder"></div>
            <div class="content-placeholder">
              <div class="title-placeholder"></div>
              <div class="desc-placeholder"></div>
            </div>
          </div>
        </div>
        } @else if (indexFilter == "map") {
        <div class="map-tab-wrapper">

          <!-- <button class="btn btn-secondary w-100 mb-2 d-block d-md-none" (click)="showMap = !showMap">
            <i [ngClass]="showMap ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
            {{ showMap ? "Hide Map" : "Show Map" }}
          </button>
          <div class="map-and-other-products" [class.active]="showMap">
            <div class="map w-100 d-flex flex-column h-100">
              <div id="map_2" class="map"></div>
            </div>

            <div class="more-prods hidden-mobile d-flex flex-column">
              <div *ngIf="areProductLoadedForOtherProducts" class="d-flex flex-column">
                <p class="w-100 mt-4 mb-3 " style="text-align: center; color: var(--primary)"><i
                    class="fas fa-heart-broken"></i> No products found for your search</p>
                <div class="w-100 mt-4 mb-3  d-flex flex-column justify-content-center similar-prod">
                  <p *ngIf="mapData.length" class="similar-prod__title">Similar Products From Other Regions</p>
                </div>
              </div>
              <app-my-carousel-swiper [config]="carouselOptionsList">
                <ng-container *ngFor="let slice of mapData; index as j">
                  <div class="swiper-slide">
                    <ng-container *ngFor="let prod of slice; index as i">
                      <div class="list--item" (click)="viewProductDetails(prod)">
                        <div class="list--item__wrapper">
                          <div class="list--item__left">
                            <span class="number">{{ i + 1 + j * 5 }}</span>
                            <img class="main-image" [src]="imgUrl + prod.indexImage" (error)="onImgError($event)" />
                            <div class="verified-tag" *ngIf="prod.productVerficationsList?.length">{{
                              (prod.verifiedTag?.trim()?.length ? prod.verifiedTag : "Verified").toLowerCase() |
                              titlecase
                              }}</div>
                          </div>
                          <div class="d-flex flex-column h-100 justify-content-between">
                            <div class="list--item__name">
                              <div class="text">
                                {{ prod.name }} <ng-container *ngIf="prod.companyName && prod.companyName != 'null'">by
                                  {{prod.companyName}}</ng-container>
                              </div>
                              <div class="icon">
                                <img [src]="imgUrl + categoryIconMap.get(prod.categoryId)" alt="" />
                              </div>
                            </div>

                            <div class="d-flex justify-content-between">
                              <span style="font-size: 0.8rem" class="mt-1">{{ formateDate(prod.created) }} </span>
                              <div class="tags d-flex align-items-end justify-content-end">
                                <ng-container *ngFor="let tag of prod.tags">
                                  <button class="tag">
                                    {{ tag.tag.substring(0, 10) }}
                                  </button>
                                </ng-container>

                                <button class="btn btn-outline-primary btn-sm mr-1"
                                  *ngIf="prod.verificationLikeCount"><i class="fa fa-thumbs-up"></i> X{{
                                  prod.verificationLikeCount }}</button>
                              </div>

                            </div>

                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </app-my-carousel-swiper>
            </div>
          </div> -->
          <ng-container *ngIf="mapData.length == 0">
            <div class="d-flex flex-column">
              <p class="w-100 mt-4 mb-3 hidden-desktop" style="text-align: center; color: var(--primary)"><i
                  class="fas fa-heart-broken"></i> No products found for your search</p>
              <div class="w-100 mt-4 mb-3 hidden-desktop d-flex flex-column justify-content-center">
                <p>Similar Products From Other Regions</p>

              </div>
            </div>
          </ng-container>

          <div class="more-prods w-100 hidden-desktop">
            <app-my-carousel-swiper [config]="carouselOptionsList">
              <ng-container *ngFor="let slice of mapData; index as j">
                <div class="swiper-slide">
                  <ng-container *ngFor="let prod of slice; index as i">
                    <div class="list--item" (click)="viewProductDetails(prod)">
                      <div class="list--item__wrapper">
                        <div class="list--item__left">
                          <span class="number">{{ i + 1 + j * 5 }}</span>
                          <img class="main-image" [src]="imgUrl + prod.indexImage" (error)="onImgError($event)" />
                          <div class="verified-tag" *ngIf="prod.productVerficationsList?.length">{{
                            (prod.verifiedTag?.trim()?.length ? prod.verifiedTag : "Verified").toLowerCase() | titlecase
                            }}</div>
                        </div>
                        <div class="d-flex flex-column h-100 justify-content-between">
                          <div class="list--item__name">
                            <div class="text">
                              {{ prod.name }} <ng-container *ngIf="prod.companyName">by
                                {{prod.companyName}}</ng-container>
                            </div>
                            <div class="icon">
                              <img [src]="imgUrl + categoryIconMap.get(prod.categoryId)" alt="" />
                            </div>
                          </div>

                          <div class="d-flex justify-content-between">
                            <span style="font-size: 0.8rem" class="mt-1">{{ formateDate(prod.created) }} </span>
                            <div class="tags d-flex align-items-end justify-content-end">
                              <button class="tag" *ngFor="let tag of prod.tags">
                                {{ tag.tag.substring(0, 10) }}
                              </button>
                              <button class="btn btn-outline-primary btn-sm mr-1" *ngIf="prod.verificationLikeCount"><i
                                  class="fa fa-thumbs-up"></i> X{{ prod.verificationLikeCount }}</button>
                            </div>

                          </div>

                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </app-my-carousel-swiper>
          </div>
          <div class="region-images my-4">
            <p class="region-images__title">Share Moments</p>
            <div class="my-2 upload-grid">
              <button *ngFor="let uploadedImage of subregionUploadedImage; index as i"
                class="uploaded-box mb-3 mr-3 position-relative rounded">
                <button *ngIf="isUserAdmin || uploadedImage.appUserId == appUserId" class="t-btn actions-btn btn-sm"
                  (clickOutside)="areActionsVisibleOnAction[i]=false"
                  (click)="areActionsVisibleOnAction[i] = !areActionsVisibleOnAction[i]">
                  <i class="fa fa-ellipsis-v"></i>
                  <div *ngIf="areActionsVisibleOnAction[i]" class="position-absolute d-flex flex-column rounded"
                    style="background-color: var(--white);top: 100%">
                    <button (click)="editUploadedImage(uploadedImage)" class="btn-sm d-flex align-items-center"><i
                        class="fa fa-pen mr-2"></i> Edit</button>
                    <button (click)="deleteUploadedImage(uploadedImage)" style="color: var(--primary) "
                      class="btn-sm d-flex align-items-center"><i class="fa fa-trash mr-2"></i> Delete</button>
                  </div>

                </button>
                <button class="btn-outline-primary btn btn-sm like-btn rxn-btn"
                  (click)="openConfrimReaction(uploadedImage)"
                  [class.active]="uploadedImage?.myRxn === 1">{{uploadedImage?.likeCounts}} <i
                    class="fa fa-thumbs-up"></i></button>

                <!-- <button class="btn-outline-primary btn btn-sm dislike-btn rxn-btn"  (click)="toggleUploadRxn(uploadedImage, 2)"
                [class.active]="uploadedImage?.myRxn === 2">{{uploadedImage?.dislikeCounts}} <i class="fa fa-thumbs-down"></i></button> -->
                <app-cropped-image [imgSrc]="imgUrl + uploadedImage.imageFile" [imgClass]="' rounded'"
                  [cropInformation]="uploadedImage.cropInformation"
                  (click)="showImagePopup(uploadedImage.imageFile, uploadedImage.caption, uploadedImage.cropInformation)"></app-cropped-image>


                <!-- <img class="rounded shadow" [src]="imgUrl + uploadedImage.imageFile" (click)="showImagePopup(uploadedImage.imageFile, uploadedImage.caption)"/> -->
              </button>

              <button (click)="openUploadSubregionImageModal()" class="btn btn-outline-primary"
                style="width: 7rem; height: 10rem;">+</button>

            </div>

          </div>
        </div>
        <!-- <div class="more-prods w-100 grid-wrap hidden-modbbile">
                <div *ngFor="let prod of allProduct.slice(9); index as i" class="list--item" style="cursor: pointer" (click)="viewProductDetails(prod)">
                  <div class="list--item--wrapper">
                    <img class="main-image" [src]="imgUrl + prod.indexImage" (error)="onImgError($event)" />
                    <div class="list--item__name">
                      <span class="mr-1">{{ i + 10 }}&#41;</span>
                      <div class="icon">
                        <img [src]="imgUrl + categoryIconMap.get(prod.categoryId)" alt="" />
                      </div>
                      <span>{{ prod.name }}</span>
                    </div>
                  </div>
                </div>
              </div> -->
        } @else {

        <div class="grid-product">
          @for (list of allProduct.data; track list) {
          <common-product-card-view (view)="viewProductDetails($event)" [list]="list"
            [isCommunityProduct]="true"></common-product-card-view>
          } @empty {
          <div class="no-product full-row my-auto">
            <div class="no-product__title">You don't have Services in your region</div>
            <button class="my-button-3" (click)="openShopPopup(indexFilter)">Add Services</button>
          </div>
          }
          <ng-container *ngFor="let list of adsList">
            <common-product-card-view (view)="viewProductDetails($event)" [list]="list" [ads]="true"
              [isCommunityProduct]="true"></common-product-card-view>
          </ng-container>
        </div>
        } @if (isLoadingAllProductMore) {
        <div class="loader xs"></div>
        } @else {
        <ng-container *ngIf="allProduct.currentPage < allProduct.lastPage">
          <div class="w-100 d-flex justify-content-center">
            <div (click)="handleLoadProducts(allProduct.currentPage + 1); isLoadingAllProductMore = true"
              class="show-more">Show More <i class="fa-solid fa-chevron-down"></i></div>
          </div>
        </ng-container>
        }

        <ng-container *ngIf="indexFilter == 'shop'">
          <button class="show-more" style="background: transparent; border: 0px"
            (click)="showDoorSteps = !showDoorSteps">
            {{ showDoorSteps ? "Hide" : "More" }}
            Doorstep
            <i *ngIf="!showDoorSteps" class="fa-solid fa-chevron-down"></i>
            <i *ngIf="showDoorSteps" class="fa-solid fa-chevron-up"></i>
          </button>
        </ng-container>
        <ng-container *ngIf="indexFilter == 'shop' && showDoorSteps">
          <span style="font-size: 1.1rem; font-weight: bold; color: var(--primary)" class="mt-2 mb-2">Doorsteps</span>

          @if (isFirstLoad) {
          <div class="loading-spinner">
            <div class="spinner-border text-dark" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            Load Products...
          </div>
          } @else {
          <div class="grid-product">
            <ng-container *ngFor="let list of allProductDoorstep.data">
              <common-product-card-view (view)="viewProductDetails($event)" [list]="list" [ads]="false"
                [isCommunityProduct]="true"></common-product-card-view>
            </ng-container>
          </div>
          @if (isLoadingDoorstepMore) {
          <div class="loader xs"></div>
          } @else {
          <div class="w-100 d-flex justify-content-center">
            <ng-container *ngIf="allProductDoorstep.currentPage < allProductDoorstep.lastPage">
              <div (click)="loadMoreDoorsteps(allProductDoorstep.currentPage + 1); isLoadingDoorstepMore = true"
                class="show-more">
                Show More Doorstep
                <i class="fa-solid fa-chevron-down"></i>
              </div>
            </ng-container>
          </div>
          } }
        </ng-container>
      </div>
    </app-my-tabs>
  </div>
  <!-- @if (!readMore && isMobile) {
    <div (click)="readMore = true" class="read-more">Read More</div>
    }  -->
  }
  <app-ask-carsouel [slides]="4"></app-ask-carsouel>

  <app-marketplace #marketplace [share]="true"></app-marketplace>
</div>